export const priceCatalog = {
  'priceCatalog.previousPublication': 'Previous publication',
  'priceCatalog.currentPublication': 'Current publication',
  'priceCatalog.name': 'Name',
  'priceCatalog.state': 'State',
  'priceCatalog.active': 'Active',
  'priceCatalog.archived': 'Archived',
  'priceCatalog.open': 'Open {name}',
  'priceCatalog.empty': 'No publications',
  'priceCatalog.emptyDetail': 'No commercial terms have been published here.',
  'priceCatalog.publication': 'Publication',
  'priceCatalog.taxPublication': 'Tax publication',
  'priceCatalog.newPublication': 'Edit for publication',
  'priceCatalog.publish': 'Publish terms',
  'priceCatalog.archive': 'Archive catalogue',
  'priceCatalog.saving': 'Saving…',
  'priceCatalog.from': 'Effective from',
  'priceCatalog.until': 'Until, excluding this date',
  'priceCatalog.addInterval': 'Add interval',
  'priceCatalog.adjustments': 'Price adjustments',
  'priceCatalog.addAdjustment': 'Add adjustment',
  'priceCatalog.key': 'Rule code',
  'priceCatalog.order': 'Application order',
  'priceCatalog.adjustmentKind': 'Adjustment',
  'priceCatalog.fixedDiscount': 'Fixed discount',
  'priceCatalog.percentDiscount': 'Percentage discount',
  'priceCatalog.fixedSurcharge': 'Fixed surcharge',
  'priceCatalog.percentSurcharge': 'Percentage surcharge',
  'priceCatalog.percent': 'Percentage',
  'priceCatalog.amount': 'Amount',
  'priceCatalog.cap': 'Maximum adjustment, optional',
  'priceCatalog.basis': 'Calculation basis',
  'priceCatalog.originalGross': 'Original gross value',
  'priceCatalog.runningGross': 'Value after prior adjustments',
  'priceCatalog.stacking': 'Combination',
  'priceCatalog.stack': 'Combined with other adjustments',
  'priceCatalog.exclusive': 'Exclusive adjustment',
  'priceCatalog.reason': 'Reason',
  'priceCatalog.reasonRequired': 'Enter a reason of at least three characters.',
  'priceCatalog.remove': 'Remove from draft',
  'priceCatalog.rateKind': 'Rate type',
  'priceCatalog.percentRate': 'Percentage',
  'priceCatalog.fixedRate': 'Fixed fee',
  'priceCatalog.fixedUnitAmount': 'Fee per service unit',
  'priceCatalog.addRate': 'Add rate',
  'priceCatalog.priceTaxMode': 'Tax and service price',
  'priceCatalog.additional': 'Added to the price',
  'priceCatalog.rateUnavailable': 'The selected tax rate is not active on this date. Assign an active rate explicitly.',
  'priceCatalog.taxSchedule': 'Tax rates',
  'priceCatalog.treatment': 'Tax treatment',
  'priceCatalog.included': 'Included in gross price',
  'priceCatalog.zero': 'Zero rate',
  'priceCatalog.exempt': 'Not taxable',
  'priceCatalog.rate': 'Rate, percent',
  'priceCatalog.addComponent': 'Add tax component',
  'priceCatalog.unsaved': 'Unpublished commercial terms',
  'priceCatalog.readOnly': 'These terms cannot be changed with the current authority or catalogue state.',
  'priceCatalog.loadFailed': 'The catalogue could not be loaded.',
  'priceCatalog.failed': 'The publication could not be saved. Your draft is retained.',
  'priceCatalog.invalid': 'The terms were refused. Check dates, sources, amounts and rule order.',
  'priceCatalog.changed': 'The catalogue or a selected source changed. Reload before publishing.',
  'priceCatalog.profileMissing': 'A financial profile is required before publishing prices.',
  'priceCatalog.currencyChanged': 'The draft currency differs from the current Clinic profile. Do not reuse the old amounts.',
  'priceCatalog.sourceUnavailable': 'A required service, branch or tax source is unavailable.',
  'priceCatalog.incomplete': 'Complete the name and dated terms before publishing.',
  'priceCatalog.reload': 'Reload stored terms',
  'priceCatalog.reloadFailed': 'Reload failed. Your draft is retained.',
  'priceCatalog.reloaded': 'Stored terms loaded. Review them before publishing.',
} as const
